import { Button } from "semantic-ui-react";
import { oneOfType, shape, string, node, func, bool, number } from "prop-types";

export const cardGridItemShape = shape({
  key: oneOfType([string, number]).isRequired,
  modelType: string,
  imageClass: string.isRequired,
  imageUrl: string.isRequired,
  url: string,
  button: shape(Button.propTypes),
  popup: shape({
    header: oneOfType([string, node]),
    content: oneOfType([string, node])
  }),
  onClick: func,
  total: number,
  isBasePrice: bool,
  isPriceOnRequest: bool,
  isMandatoryDisplay: bool
});

export default cardGridItemShape;
